import React, { createContext, useContext, useState } from "react";

const ModeContext = createContext();

export const useMode = () => {
  const context = useContext(ModeContext);
  if (!context) {
    throw new Error("useMode must be used within a ModeProvider");
  }
  return context;
};

export const ModeProvider = ({ children }) => {
  const [isAgentMode, setIsAgentMode] = useState(() => {
    // Load from localStorage if available
    const saved = localStorage.getItem('agentMode');
    return saved ? JSON.parse(saved) : false;
  });

  const toggleMode = () => {
    const newMode = !isAgentMode;
    setIsAgentMode(newMode);
    // Save to localStorage
    localStorage.setItem('agentMode', JSON.stringify(newMode));
  };

  const value = {
    isAgentMode,
    setIsAgentMode,
    toggleMode,
  };

  return <ModeContext.Provider value={value}>{children}</ModeContext.Provider>;
};
